import { MapStyle } from '~/common/types';
import images from './assets';

interface TBasemapStyle {
  label: string;
  img: string;
  style: string;
}

export const basemapStyles: TBasemapStyle[] = [
  {
    label: 'CivilGrid Light',
    img: images.civilGridLight,
    style: MapStyle.civilGridLight,
  },
  {
    label: 'CivilGrid Dark',
    img: images.civilGridDark,
    style: MapStyle.civilGridDark,
  },
  {
    label: 'Streets',
    img: images.streets,
    style: MapStyle.streets,
  },
  {
    label: 'Outdoors',
    img: images.outdoors,
    style: MapStyle.outdoors,
  },
  {
    label: 'Light',
    img: images.light,
    style: MapStyle.light,
  },
  {
    label: 'Dark',
    img: images.dark,
    style: MapStyle.dark,
  },
  {
    label: 'Satellite',
    img: images.satellite,
    style: MapStyle.satellite,
  },
  {
    label: 'Satellite w/o streets',
    img: images.satellite,
    style: MapStyle.satelliteWithoutStreets,
  },
];
